import { Col, Row, Typography } from 'antd';
import React from 'react';
import { ClosingReport } from '~/types/Report';
import { formatDateTime } from '~/utils/date';

const CashierInfo = ({ report }: { report: ClosingReport }) => {
  const { cashier, openTime, closeTime } = report;
  return (
    <div>
      <div style={{ marginBottom: 12 }}>
        <Typography.Text strong>Kasir: </Typography.Text>
        <Typography.Text>{cashier.name}</Typography.Text>
      </div>
      <Row>
        <Col span={12} className="d-flex flex-column">
          <Typography.Text strong>Waktu Buka Kasir</Typography.Text>
          <Typography.Text>{formatDateTime(openTime)}</Typography.Text>
        </Col>
        <Col span={12} className="d-flex flex-column text-center">
          <Typography.Text strong>Waktu Tutup Kasir</Typography.Text>
          <Typography.Text>{formatDateTime(closeTime)}</Typography.Text>
        </Col>
      </Row>
    </div>
  );
};

export default CashierInfo;
